import { useNavigate, useParams } from "react-router-dom"
import { useGetEmployeeDetailQuery, useGetEmployeeLogsQuery } from "../../store/api/employeeApi"
import { Card, Col, Descriptions, Empty, Row, Tag, Typography, Timeline, Collapse, Button } from "antd"
import LoadingBlock from "../../components/loader/LoadingBlock"
import ErrorNotFound from "../../components/error/ErrorNotFound"
import { ArrowLeftOutlined } from "@ant-design/icons"
import dayjs from "dayjs";

export const EployeeDetailsPage = () => {
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()
    const { data: employeeData, isLoading, error } = useGetEmployeeDetailQuery(Number(id))
    const details = employeeData?.data
    const { data: logs } = useGetEmployeeLogsQuery(Number(id))
    const logsJson = logs?.data

    if (isLoading) {
        return <div><LoadingBlock /></div>
    }

    if (error) {
        return <div><ErrorNotFound /></div>
    }

    if (!details) {
        return <div><Empty description="Сотрудник не найден" /></div>
    }

    return (
        <div className="p-6">
               <Button
                  type="link"
                  icon={<ArrowLeftOutlined />}
                  onClick={() => navigate(-1)}
                  style={{ marginBottom: 16 }}
                   >
                   Назад
                  </Button>
            {employeeData && (
                <>
                    <Card style={{ marginBottom: "30px" }}>
                        <Row gutter={24}>
                            <Col span={12}>
                                <Descriptions
                                    title={<Typography.Title level={4}>Личная информация</Typography.Title>}
                                    column={1}
                                    bordered
                                >
                                    <Descriptions.Item label="Фамилия">{details.last_name}</Descriptions.Item>
                                    <Descriptions.Item label="Имя">{details.first_name}</Descriptions.Item>
                                    <Descriptions.Item label="Отчество">{details.middle_name}</Descriptions.Item>
                                    <Descriptions.Item label="Дата рождения">{dayjs(details.birthday).format('DD.MM.YYYY')}</Descriptions.Item>
                                    <Descriptions.Item label="Эл. почта">
                                        <Typography.Link href={`mailto:${details.email}`}>
                                            {details.email}
                                        </Typography.Link>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Телефон">
                                        <Typography.Link href={`tel:${details.phone}`}>
                                            {details.phone}
                                        </Typography.Link>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Адрес">{details.address}</Descriptions.Item>
                                    <Descriptions.Item label="ПИНФЛ">{details.pinfl}</Descriptions.Item>
                                </Descriptions>
                            </Col>

                            <Col span={12}>
                                <Descriptions
                                    title={<Typography.Title level={4}>Информация о работе</Typography.Title>}
                                    column={1}
                                    bordered
                                >
                                    <Descriptions.Item label="Дата приема">{dayjs(details.hireDate).format('DD.MM.YYYY')}</Descriptions.Item>
                                    <Descriptions.Item label="Дата увольнения">
                                        {details.fireDate || <Tag color="success">Активный</Tag>}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="ID в Tax Pay">{details.taxi_pay_id}</Descriptions.Item>
                                    <Descriptions.Item label="Отдел IIKO">{details.iiko_department_name}</Descriptions.Item>
                                    <Descriptions.Item label="Должность IIKO">{details.iiko_role_name}</Descriptions.Item>
                                    <Descriptions.Item label="Отдел ISpring">
                                        {details.ispring_department_name || <Tag color="default">Нет</Tag>}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Должность ISpring">
                                        {details.ispring_role_name || <Tag color="default">Нет</Tag>}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Отдел 1С ЗУП">{details.oneczup_department_name}</Descriptions.Item>
                                    <Descriptions.Item label="Должность 1С ЗУП">{details.oneczup_role_name}</Descriptions.Item>
                                </Descriptions>
                            </Col>
                        </Row>
                    </Card>

                    {logsJson && logsJson.length > 0 && (
                        <Card title={<Typography.Title level={4}>История изменений</Typography.Title>}>
                            <Timeline>
                                {logsJson.map((log) => {
                                    const changes = log.value
                                    const {
                                        code,
                                        email,
                                        phone,
                                        pinfl,
                                        address,
                                        roleUID,
                                        birthday,
                                        fireDate,
                                        hireDate,
                                        lastName,
                                        roleName,
                                        firstName,
                                        isDeleted,
                                        middleName,
                                        departmentUID,
                                        departmentName,
                                        taxpayerIdNumber,
                                        departmentParentUID,
                                        departmentParentName,
                                    } = changes;

                                    return (
                                        <Timeline.Item key={log.id}>
                                            <Collapse>
                                                <Collapse.Panel
                                                    header={
                                                        <Typography.Text strong>
                                                            {new Date(log.created_date).toLocaleString()}
                                                        </Typography.Text>
                                                    }
                                                    key={log.id}
                                                >
                                                    <Descriptions column={1} size="small">
                                                        <Descriptions.Item label="Код">{code || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Email">{email || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Телефон">{phone || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="ПИНФЛ">{pinfl || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Адрес">{address || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Дата рождения">
                                                            {birthday ? new Date(birthday).toLocaleDateString() : 'Нет данных'}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Дата увольнения">
                                                            {fireDate ? new Date(fireDate).toLocaleDateString() : 'Активный'}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Дата приема">
                                                            {hireDate ? new Date(hireDate).toLocaleDateString() : 'Нет данных'}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Фамилия">{lastName || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Имя">{firstName || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Отчество">{middleName || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Должность">{roleName || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Отдел">{departmentName || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="roleUID">{roleUID || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Статус">
                                                            {isDeleted ? <Tag color="error">Удален</Tag> : <Tag color="success">Активный</Tag>}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="ID департамента">{departmentUID || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="ID родителя департамента">{departmentParentUID || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Называние родителя департамента">{departmentParentName || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="ID плательшика налога">{taxpayerIdNumber || 'Нет данных'}</Descriptions.Item>
                                                        <Descriptions.Item label="Статус изменения">{log.iiko_status || 'Нет данных'}</Descriptions.Item>
                                                    </Descriptions>
                                                </Collapse.Panel>
                                            </Collapse>
                                        </Timeline.Item>
                                    );
                                })}
                            </Timeline>
                        </Card>
                    )}
                </>
            )}
        </div>
    )
}
